export default __webpack_public_path__ + "stat-users.d7020f26.svg";